import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { calculateFees } from '../../components/amountHelper';
import { headerPublic } from '../../components/header.encry';
import Modal from '../../components/Modal';
const API_URL = process.env?.REACT_APP_PEGASUS_API_URL;
function StoreShop({ products, setProducts, productCategories, setProductCategories, id }) {

    const [stores, setStores] = useState([]); // Store list for dropdown
    const [zoomedImage, setZoomedImage] = useState(null); // For big image preview
    const [selectCategory, setSelectedCategory] = useState('featured');
    useEffect(() => {
        if (products.length == 0)
            fetchProducts();
        fetchStores(); // Fetch stores for dropdown
    }, []);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const openModal = (product) => {
        setSelectedProduct(product);
    };

    const closeModal = () => {
        setSelectedProduct(null);
    };


    const fetchProducts = async () => {
        const response = await axios.get(`${API_URL}/products/${id}`, headerPublic());
        setProducts(response.data.map(product => ({ ...product, quantity: 0 })));
        const response_ = await axios.get(`${API_URL}/productsCategories`, headerPublic());
        setProductCategories(response_.data);

    };
    const fetchStores = async () => {

        const response = await axios.get(`${API_URL}/distinctStoreIds`, headerPublic());
        setStores(response.data.response.map(store => ({
            value: store.storeCode,
            label: store.name,
            type: store.store_type,
            fees: store.fees
        })));
    };
    const handleQuantity = (id, quantity) => {
        if (quantity >= 0) {
            setProducts(products.map(p =>
                p._id === id ? { ...p, quantity: quantity } : p
            ));
        }

    };

    const [visibleCount, setVisibleCount] = useState(30);
    const loadingRef = useRef(false);
    const [sortMode, setSortMode] = useState(null);
    const currentStore = stores.find((store) => String(store.value) === String(id));

    const selectStoreCategory = (categoryId) => {
        setSelectedCategory(categoryId);
        setVisibleCount(30);
    };

    const getProductCategoryId = (product) => {
        const category = product?.category_id || product?.category;
        if (category && typeof category === 'object') {
            return String(category._id || category.id || category.value || '');
        }
        return String(category || '');
    };

    const isProductFeaturedForCurrentStore = (product) => {
        if (product?.storeExpressFeatured === true) {
            return true;
        }

        if (!Array.isArray(product?.stores)) {
            return false;
        }

        const storeEntry = product.stores.find((store) => String(store?.store_id || store?.storeCode || store?.code || '') === String(id));
        return Boolean(storeEntry?.featured);
    };

    const getStoreExpressPrice = (product) => {
        const basePrice = Number(product?.regular_price) || 0;
        const feeType = currentStore?.fees?.type || 'amount';
        const feeValue = Number(currentStore?.fees?.value) || 0;
        return Math.ceil(calculateFees(feeType, feeValue, basePrice) + basePrice);
    };

    useEffect(() => {
        const onScroll = () => {
            if (selectCategory !== null) return;
            if (visibleCount >= products.length) return;
            const nearBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 200;
            if (nearBottom && !loadingRef.current) {
                loadingRef.current = true;
                setVisibleCount(v => Math.min(products.length, v + 30));
                setTimeout(() => { loadingRef.current = false; }, 600);
            }
        };
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, [visibleCount, products.length, selectCategory]);

    const getVisibleProducts = () => products.filter((product) => {
        if (selectCategory === 'featured') return isProductFeaturedForCurrentStore(product);
        if (selectCategory === null) return true;
        return getProductCategoryId(product) === String(selectCategory);
    });

    const filteredCount = getVisibleProducts().length;
    return (
        <div style={{ paddingTop: 32 }}>
            <div className='row' style={{ marginTop: 0 }}>
                <div className='col-3'>
                    <div className="d-flex flex-column flex-shrink-0 p-3" style={{ width: '100%', backgroundColor: '#ffffff', borderRadius: 6, boxSizing: 'border-box', position: 'sticky', top: 84, height: 'calc(100vh - 84px)', alignSelf: 'flex-start', overflow: 'auto' }}>
                        <a href="/" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto link-body-emphasis text-decoration-none" style={{ textDecoration: 'none' }}>
                            <svg className="bi pe-none me-2" width="40" height="32"><use xlinkHref="#bootstrap" /></svg>
                            <h1 style={{ fontSize: 28, margin: 0, fontWeight: 800 }}>Catégorie</h1>
                        </a>
                                                <hr />
                                                <style>{`
                        .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
                        .hide-scrollbar::-webkit-scrollbar { width: 0; height: 0; }
                        .hide-scrollbar:hover { -ms-overflow-style: auto; scrollbar-width: thin; }
                        .hide-scrollbar:hover::-webkit-scrollbar { width: 8px; }
                        .hide-scrollbar:hover::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.2); border-radius: 4px; }
                        .store-express-card {
                            border: 1px solid rgba(15, 23, 42, 0.08);
                            border-radius: 22px;
                            overflow: hidden;
                            background: #fff;
                            box-shadow: 0 14px 34px rgba(15, 23, 42, 0.08);
                            transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;
                        }
                        .store-express-card:hover {
                            transform: translateY(-4px);
                            border-color: rgba(21, 128, 61, 0.22);
                            box-shadow: 0 22px 44px rgba(15, 23, 42, 0.14);
                        }
                        .store-express-card.is-selected {
                            border-color: rgba(22, 163, 74, 0.45);
                            box-shadow: 0 18px 42px rgba(22, 163, 74, 0.16);
                        }
                        .store-product-image {
                            position: relative;
                            aspect-ratio: 1/1;
                            min-height: 180px;
                            background-size: cover;
                            background-position: center;
                            cursor: zoom-in;
                        }
                        .store-product-image::after {
                            content: "";
                            position: absolute;
                            inset: 0;
                            background: linear-gradient(180deg, rgba(15, 23, 42, 0.02) 42%, rgba(15, 23, 42, 0.32) 100%);
                            opacity: 0;
                            transition: opacity 180ms ease;
                        }
                        .store-express-card:hover .store-product-image::after {
                            opacity: 1;
                        }
                        .store-product-badge {
                            position: absolute;
                            top: 12px;
                            left: 12px;
                            z-index: 2;
                            display: inline-flex;
                            align-items: center;
                            gap: 6px;
                            border-radius: 999px;
                            padding: 7px 11px;
                            color: #14532d;
                            background: rgba(240, 253, 244, 0.94);
                            border: 1px solid rgba(34, 197, 94, 0.22);
                            font-size: 12px;
                            font-weight: 800;
                            letter-spacing: 0.02em;
                            box-shadow: 0 8px 18px rgba(15, 23, 42, 0.10);
                        }
                        .store-product-zoom {
                            position: absolute;
                            right: 12px;
                            top: 12px;
                            z-index: 2;
                            width: 36px;
                            height: 36px;
                            border-radius: 50%;
                            border: 0;
                            color: #0f172a;
                            background: rgba(255, 255, 255, 0.92);
                            box-shadow: 0 8px 18px rgba(15, 23, 42, 0.14);
                        }
                        .store-product-body {
                            padding: 14px 14px 16px;
                            min-height: 148px;
                        }
                        .store-product-title {
                            min-height: 44px;
                            color: #111827;
                            font-size: 15px;
                            font-weight: 800;
                            line-height: 1.28;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                        }
                        .store-product-price {
                            color: #0f5132;
                            font-size: 20px;
                            font-weight: 900;
                            letter-spacing: -0.03em;
                        }
                        .store-product-currency {
                            color: #64748b;
                            font-size: 12px;
                            font-weight: 800;
                            margin-left: 4px;
                            letter-spacing: 0.04em;
                        }
                        .store-cart-icon-btn {
                            width: 46px;
                            height: 46px;
                            border-radius: 16px;
                            border: 0;
                            color: #fff;
                            background: linear-gradient(135deg, #0f766e 0%, #16a34a 100%);
                            box-shadow: 0 10px 22px rgba(15, 118, 110, 0.24);
                            transition: transform 160ms ease, box-shadow 160ms ease;
                        }
                        .store-cart-icon-btn:hover {
                            transform: translateY(-2px);
                            box-shadow: 0 14px 28px rgba(15, 118, 110, 0.32);
                        }
                        .store-qty-control {
                            display: inline-flex;
                            align-items: center;
                            gap: 8px;
                            padding: 6px;
                            border-radius: 16px;
                            background: #f8fafc;
                            border: 1px solid #e2e8f0;
                        }
                        .store-qty-btn {
                            width: 36px;
                            height: 36px;
                            border-radius: 13px;
                            border: 1px solid rgba(15, 118, 110, 0.16);
                            background: #fff;
                            color: #0f766e;
                            box-shadow: 0 5px 14px rgba(15, 23, 42, 0.10);
                            transition: transform 150ms ease, color 150ms ease, background 150ms ease, box-shadow 150ms ease;
                        }
                        .store-qty-btn:hover {
                            transform: translateY(-1px);
                            background: #f0fdfa;
                            color: #115e59;
                            box-shadow: 0 8px 18px rgba(15, 118, 110, 0.16);
                        }
                        .store-qty-btn.is-minus {
                            color: #64748b;
                            border-color: rgba(100, 116, 139, 0.18);
                        }
                        .store-qty-btn.is-minus:hover {
                            background: #f8fafc;
                            color: #334155;
                        }
                        .store-qty-value {
                            min-width: 26px;
                            text-align: center;
                            font-weight: 900;
                            color: #0f5132;
                        }
                        `}</style>
                                                <div style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 200px)' }} className="hide-scrollbar">
                                                    <ul className="nav nav-pills flex-column mb-auto">
                                                        <li className="nav-item">
                                                            <a className={`nav-link ${selectCategory === 'featured' ? 'active' : ''}`} onClick={() => selectStoreCategory('featured')} aria-current="page" style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 12px' }}>
                                                                <div style={{ width: 71, height: 71, borderRadius: '50%', background: '#f2f2f2', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <i className="fa-solid fa-star" style={{ fontSize: 22, color: '#d97706' }} />
                                                                </div>
                                                                <span style={{ flex: 1, textAlign: 'left', fontSize: 19, fontWeight: 700 }}>Recommandé</span>
                                                            </a>
                                                        </li>
                                                        {productCategories
                                                            .filter((c) => c.type === 'pegasus')
                                                            .map((x) => (
                                                                <li className="nav-item" key={x._id}>
                                                                    <a
                                                                        className={`nav-link ${x._id == selectCategory ? 'active' : ''}`}
                                                                        onClick={() => selectStoreCategory(x._id)}
                                                                        aria-current="page"
                                                                        style={{ display: 'flex', alignItems: 'center', gap: 12, justifyContent: 'flex-start', padding: '8px 10px' }}
                                                                    >
                                                                        {x.image ? (
                                                                            <img
                                                                                src={/^https?:\/\//i.test(x.image) ? x.image : `${process.env.REACT_APP_PEGASUS_API_URL}${x.image}`}
                                                                                alt={x.name}
                                                                                style={{ width: 71, height: 71, borderRadius: '50%', objectFit: 'cover', background: '#f2f2f2' }}
                                                                            />
                                                                        ) : (
                                                                            <div style={{ width: 71, height: 71, borderRadius: '50%', background: '#f2f2f2' }} />
                                                                        )}
                                                                        <span style={{ flex: 1, textAlign: 'left', alignSelf: 'center', fontSize: 19, fontWeight: 700 }}>{x.name}</span>
                                                                    </a>
                                                                </li>
                                                            ))}
                                                        <li className="nav-item">
                                                            <a className={`nav-link ${null == selectCategory ? 'active' : ''}`} onClick={() => selectStoreCategory(null)} aria-current="page" style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 12px' }}>
                                                                <div style={{ width: 71, height: 71, borderRadius: '50%', background: '#f2f2f2', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <i className="fa-solid fa-box-open" style={{ fontSize: 22, color: '#6b7280' }} />
                                                                </div>
                                                                <span style={{ flex: 1, textAlign: 'left', fontSize: 19, fontWeight: 700 }}>Tout</span>
                                                            </a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a className={`nav-link`} onClick={() => fetchProducts()} aria-current="page" style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 12px' }}>
                                                                <div style={{ width: 71, height: 71, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid #e6edf8', background: '#fff' }}>
                                                                    <i className="fa-solid fa-rotate-right" style={{ fontSize: 20, color: '#1f6feb' }} />
                                                                </div>
                                                                <span style={{ flex: 1, textAlign: 'left', fontSize: 19, fontWeight: 700 }}>Reload</span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                        <br />
                    </div>
                </div>
                <div className='col-9'>

                    <div className="d-flex justify-content-end mb-3">
                        <select className="form-select w-auto" value={sortMode || ''} onChange={(e) => setSortMode(e.target.value || null)}>
                            <option value="">Trier</option>
                            <option value="price-asc">Tarif Croissant -</option>
                            <option value="price-desc">Décroissant Tarif +</option>
                            <option value="recent">Les plus récents</option>
                        </select>
                    </div>

                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4 g-3">
                        {(() => {
                            const filtered = getVisibleProducts();
                            let sorted = [...filtered];
                            if (sortMode === 'price-asc') {
                                sorted.sort((a, b) => (Number(a.regular_price) || 0) - (Number(b.regular_price) || 0));
                            } else if (sortMode === 'price-desc') {
                                sorted.sort((a, b) => (Number(b.regular_price) || 0) - (Number(a.regular_price) || 0));
                            } else if (sortMode === 'recent') {
                                sorted.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                            }
                            const visible = sorted.slice(0, selectCategory === null ? visibleCount : products.length);
                            return visible.map((product) => (
                                <div className="col" key={product._id}>
                                    <div className={`store-express-card h-100 d-flex flex-column ${(product.quantity > 0) ? 'is-selected' : ''}`}>
                                        <div
                                            className="store-product-image"
                                            style={{
                                                backgroundImage: `url("${process.env.REACT_APP_DATA_PIC_PATH}/image.resize.php?path=${product.url_product}")`,
                                            }}
                                            onClick={() => setZoomedImage(`${process.env.REACT_APP_DATA_PIC_PATH}/${product.url_product}`)}
                                        >
                                            {isProductFeaturedForCurrentStore(product) && (
                                                <span className="store-product-badge">
                                                    <i className="fa-solid fa-star"></i>
                                                    Recommande
                                                </span>
                                            )}
                                            <button
                                                type="button"
                                                className="store-product-zoom"
                                                title="Agrandir"
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    setZoomedImage(`${process.env.REACT_APP_DATA_PIC_PATH}/${product.url_product}`);
                                                }}
                                            >
                                                <i className="fa-solid fa-magnifying-glass-plus"></i>
                                            </button>
                                        </div>
                                        <div className="store-product-body d-flex flex-column">
                                            <div className="store-product-title" title={product.name}>{product.name}</div>
                                            <div className="mt-auto d-flex justify-content-between align-items-end gap-2">
                                                <div>
                                                    <div className="small text-muted fw-semibold">Prix</div>
                                                    <div className="store-product-price">
                                                        {getStoreExpressPrice(product)}
                                                        <span className="store-product-currency">DHS</span>
                                                    </div>
                                                </div>
                                                {product.quantity === 0 ? (
                                                    <button
                                                        className="store-cart-icon-btn"
                                                        onClick={() => handleQuantity(product._id, 1)}
                                                        type="button"
                                                        title="Ajouter au panier"
                                                        aria-label={`Ajouter ${product.name} au panier`}
                                                    >
                                                        <i className="fa-solid fa-bag-shopping"></i>
                                                    </button>
                                                ) : (
                                                    <div className="store-qty-control" aria-label={`Quantite ${product.name}`}>
                                                        <button className="store-qty-btn is-minus" onClick={() => handleQuantity(product._id, product.quantity - 1)} type="button" title="Retirer">
                                                            <i className="fa-solid fa-minus"></i>
                                                        </button>
                                                        <span className="store-qty-value">{product.quantity}</span>
                                                        <button className="store-qty-btn is-plus" onClick={() => handleQuantity(product._id, product.quantity + 1)} type="button" title="Ajouter">
                                                            <i className="fa-solid fa-plus"></i>
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ));
                        })()}
                    </div>

                    {selectCategory === null && filteredCount > visibleCount ? (
                        <div className="d-flex justify-content-center mt-3">
                            <button className="btn btn-outline-primary" onClick={() => setVisibleCount(v => v + 30)}>Charger plus</button>
                        </div>
                    ) : null}
                    </div>

                </div>
                        {zoomedImage && (
                            <div 
                                style={{
                                    position: 'fixed',
                                    top: 0,
                                    left: 0,
                                    width: '100vw',
                                    height: '100vh',
                                    backgroundColor: 'rgba(0,0,0,0.9)',
                                    zIndex: 9999,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer'
                                }}
                                onClick={() => setZoomedImage(null)}
                            >
                                <div style={{ position: 'relative', maxWidth: '90%', maxHeight: '90%' }}>
                                    <img 
                                        src={zoomedImage} 
                                        alt="Preview" 
                                        style={{ maxWidth: '100%', maxHeight: '90vh', objectFit: 'contain' }}
                                    />
                                    <button 
                                        style={{
                                            position: 'absolute',
                                            top: -40,
                                            right: 0,
                                            background: 'white',
                                            border: 'none',
                                            borderRadius: '50%',
                                            width: 40,
                                            height: 40,
                                            fontSize: 20,
                                            cursor: 'pointer'
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setZoomedImage(null);
                                        }}
                                    >
                                        ×
                                    </button>
                                </div>
                            </div>
                        )}

        </div>
    );


}

export default StoreShop;
